// extracted by mini-css-extract-plugin
export var enOnlyLabel = "WgxpA";
export var playButton = "n-BPi";